import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { text: String };
  static targets = ["source", "button"];

  copy() {
    const text = this.hasTextValue
      ? this.textValue
      : this.hasSourceTarget
      ? this.sourceTarget.innerText
      : "";

    if (!text) return;

    navigator.clipboard.writeText(text)
      .then(() => {
        this.showCopiedState();
        this.dispatch("success", { detail: { text } });
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
        this.dispatch("error", { detail: { error: err } });
      });
  }

  showCopiedState() {
    if (!this.hasButtonTarget) return;

    const button = this.buttonTarget;
    const originalText = button.innerText;

    button.innerText = "Copied!";
    button.disabled = true;

    setTimeout(() => {
      button.innerText = originalText;
      button.disabled = false;
    }, 1500);
  }
}
